export default "__VITE_ASSET__C_48swiT__"